import { ColumnSettings, ColumnTypes, TableFilterType } from '@app/sharedModule/models/table-settings.model';
import { TranslatedFulfillmentStatus } from '@pdqdev/pdq-shared/dist/OrderData';

export const ordersToManifestColumnsConfig: ColumnSettings[] = [
  {
    type: ColumnTypes.CHECKBOX,
    prop: 'checkbox',
    hideColumnName: true,
    sortable: false,
    width: 35,
    minWidth: 35,
    maxWidth: 35,
  },
  {
    type: ColumnTypes.ORDER_NUMBER,
    prop: 'orderNumber',
    name: 'Order no.',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    fraudRisk: true,
    sortDirection: null,
    unHold: true,
    unSchedule: true,
    pendingPayment: true,
    inventoryOutOfStock: true,
    split: true,
    merged: true,
    canBeHide: true,
    default: true,
  },
  {
    prop: 'externalOrderNumber',
    name: 'External order number',
    type: ColumnTypes.TEXT,
    width: 50,
    minWidth: 50,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    filterValue: '',
    canBeHide: true,
    default: false,
  },
  {
    type: ColumnTypes.TEXT,
    sortable: true,
    prop: 'deliveryTransaction.shippingId',
    name: 'Tracking number',
    filterFields: 'shippingId',
    filterOption: 'LIKE',
    filterValue: '',
    width: 70,
    minWidth: 70,
    sortFieldName: ['shippingId'],
    filterType: TableFilterType.TEXT,
  },
  {
    type: ColumnTypes.FULFILLMENT,
    sortable: true,
    prop: 'fulfillmentStatus',
    name: 'Fulfillment status',
    width: 70,
    minWidth: 70,
    filterType: TableFilterType.SELECT,
    filterSelectOptions: [
      {
        value: TranslatedFulfillmentStatus.FULFILLED,
        text: 'Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.PARTIALLY_FULFILLED,
        text: 'Partially Fulfilled',
      },
      {
        value: TranslatedFulfillmentStatus.NOT_FULFILLED,
        text: 'Unfulfilled',
      },
    ],
    filterOption: 'LIKE',
    sortDirection: '',
  },
  {
    prop: 'batchName',
    name: 'Batch name',
    width: 100,
    minWidth: 100,
    filterType: TableFilterType.TEXT,
    filterOption: 'LIKE',
    sortDirection: '',
    sortFieldName: ['orderBatch'],
    canBeHide: true,
    default: true,
  },
  {
    prop: 'deliveryPromise',
    name: 'Delivery promise',
    type: ColumnTypes.DELIVERY_PROMISE,
    filterType: TableFilterType.DATE,
    filterOption: 'DATE RANGE',
    width: 190,
    minWidth: 190,
    maxWidth: 260,
    filterFields: 'deliveryDate',
    sortFieldName: ['deliveryDate'],
    default: true,
  },
];
